export default __webpack_public_path__ + "static/media/speedgame.b8cfb28b.PNG";